import axios from '../api'
//散客门票预约日历
const calendar = () =>
	axios(
		'/ticket/calendar', {
			p: 'w'
		}
	)
//相关文字显示
const textTip = () =>
	axios(
		'/ticket/text_tip', {
			p: 'w'
		}
	)
//门票详情
const ticketDetail = (td_tp_id = '') =>
	axios(
		'/ticket/detail', {
			p: 'w',
			td_tp_id
		}
	)
//提交预约订单
const submitForm = (url, submitData = {}) =>
	axios(
		url, { ...{
				p: 'w',
				api_token: localStorage.getItem('personal_user_info') && JSON.parse(localStorage.getItem('personal_user_info')).api_token || '',
				contact_phone: sessionStorage.getItem('contact_phone')
			},
			...submitData
		}, 'POST', {
			type: 'personal'
		}
	)
//门票订单状态数组
const orderStatus = () =>
	axios(
		'/ticket/order_status_search', {
			p: 'w',
			order_type: 1
		}
	)
//门票订单记录
const orderRecord = (url = '', submitData = {}) =>
	axios(
		url, { ...{
				p: 'w'
			},
			...submitData
		}, 'GET', {
			type: 'personal'
		}
	)
//订单详情
const orderDetail = (url = '', submitData = {}) =>
	axios(
		url, { ...{
				p: 'w'
			},
			...submitData
		}, 'GET', {
			type: 'personal'
		}
	)
//退票
const refundTicket = (url, submitData = {}) =>
	axios(
		url, { ...{
				p: 'w'
			},
			...submitData
		}, 'POST', {
			type: 'personal'
		}
	)
export default {
	calendar,
	textTip,
	ticketDetail,
	submitForm,
	orderStatus,
	orderRecord,
	orderDetail,
	refundTicket
}


// WEBPACK FOOTER //
// ./src/http/modules/personal.js